/**
 * Chương trình khuyến mãi hiển thị ở /tin-tuc/khuyen-mai/ và khối "Ưu đãi tại An Thư" của /tin-tuc/.
 * Nội dung theo bản thiết kế 12/10/2026. Muốn đổi chương trình / thời gian / link: sửa ở file này.
 * Ảnh poster lấy từ ảnh đại diện của bài tương ứng trên anthu.today (slug bên dưới).
 */
export type Promo = {
  slug: string;
  /** slug bài viết trên anthu.today — nguồn ảnh poster và link "xem điều kiện" */
  article: string;
  ended: boolean;
  /** nhãn trạng thái */
  status: string;
  /** tên chương trình (xuống dòng bằng \n) */
  title: string;
  /** tên ngắn trên thẻ */
  short: string;
  /** thời gian áp dụng (hiển thị) */
  period: string;
  /** ngày bắt đầu / kết thúc dạng ISO (YYYY-MM-DD) cho dữ liệu có cấu trúc Offer; bỏ trống nếu không có mốc */
  validFrom?: string;
  validThrough?: string;
  desc: string;
  highlights?: { value: string; label: string }[];
  note?: string;
  cta: string;
  /** nhãn nút ngắn trên thẻ ở /tin-tuc/ */
  shortCta?: string;
};

export const PROMOS: Promo[] = [
  {
    slug: 'thang-10-tron-ven',
    article: 'thang-10-tron-ven',
    ended: false,
    status: 'ĐANG DIỄN RA',
    title: 'Tháng 10\ntrọn vẹn.',
    short: 'Tháng 10 trọn vẹn',
    period: '01 - 31/10/2026',
    validFrom: '2026-10-01',
    validThrough: '2026-10-31',
    desc: 'Một tháng để chọn món trang sức yêu thích, với hai lựa chọn ưu đãi theo chương trình.',
    highlights: [
      { value: '15%', label: 'Ưu đãi theo chương trình' },
      { value: '70 triệu', label: 'Quà tặng tối đa' },
    ],
    note: 'Lựa chọn ưu đãi theo giá trị đơn hàng và điều kiện được An Thư công bố.',
    cta: 'Xem điều kiện chương trình',
    shortCta: 'Xem chương trình',
  },
  {
    slug: 'doi-lon-0',
    article: 'doi-lon-0-giu-tron-gia-tri',
    ended: false,
    status: 'ĐANG DIỄN RA',
    title: 'Đổi lớn 0%.\nGiữ trọn giá trị.',
    short: 'Đổi lớn 0%',
    period: 'Áp dụng từ 02/10/2026 đến khi có thông báo mới.',
    validFrom: '2026-10-02',
    desc: 'Đổi trang sức theo chính sách giữ nguyên giá trị sản phẩm cũ, với điều kiện áp dụng của An Thư.',
    cta: 'Xem chính sách đổi lớn',
    shortCta: 'Xem chính sách',
  },
  {
    slug: 'don-anh-trang-vang',
    article: 'don-anh-trang-vang-anthu-trao-toa-sang',
    ended: true,
    status: 'ĐÃ KẾT THÚC · THÁNG 9/2026',
    title: 'Đón ánh trăng vàng,\nAn Thư trao tỏa sáng.',
    short: 'Đón ánh trăng vàng',
    period: 'Tháng 9/2026',
    desc: 'Chương trình mùa Trung thu đã kết thúc.',
    cta: 'Xem lại chương trình',
  },
];

export type PromoImages = Record<string, string>;
